module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"draft":"Draft","saved":"Saved","archive":"Archive","copy":"Copy","delete":"Delete","vacancyDeleted":"Job deleted","vacancyArchived":"Job archived","vacancyCopied":"Job copied","dateChangeSuccessMessage":"Job publication period was changed","setUpScenario":"Set up interview scenario","processingByAi":"Processing by AI","yes":"Yes","no":"No"}}')
  delete Component.options._Ctor
}
